import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IModelDetailParams, IModelDetailResponse, IModelDetailState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchCreateModelDetail = createAsyncThunk(
  'listModelDetails/fetchCreateModelDetail',
  async (params: IModelDetailParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.createModelDetails(params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IModelDetailState = {
  isLoading: false,
  response: null,
  error: null
}

const createModelDetailSlice = createSlice({
  name: 'modeldetails/show',
  initialState,
  reducers: {
    resetCreateModelDetail: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchCreateModelDetail.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchCreateModelDetail.fulfilled, (state, action: PayloadAction<IModelDetailResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchCreateModelDetail.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default createModelDetailSlice.reducer
export const { resetCreateModelDetail } = createModelDetailSlice.actions
